/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslinkcopy2Inputs */

const en_groupslinkcopy2 = /** @type {(inputs: Groupslinkcopy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const de_groupslinkcopy2 = /** @type {(inputs: Groupslinkcopy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Groupslinkcopy2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslinkcopy2 = /** @type {((inputs?: Groupslinkcopy2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslinkcopy2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslinkcopy2(inputs)
	return de_groupslinkcopy2(inputs)
});
export { groupslinkcopy2 as "groupsLinkCopy" }